import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; // 🔹 추가
import Layout from "./components/Layout";
import RequireLogin from "./components/RequireLogin";
import { ToastProvider } from "./components/ui/Toast";
import Main from "./pages/Main";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import FoodSearch from './pages/FoodSearch';
import FoodMy from './pages/FoodMy';
import DietCalendar from './pages/DietCalendar';
import DietRecommend from './pages/DietRecommend';
import MyPage from './pages/MyPage';
import "./App.css";



function App() {

  return (
    <Router>
      <ToastProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            <Route path="/food-search" element={<FoodSearch />} />
            <Route path="/food-my" element={<RequireLogin><FoodMy /></RequireLogin>} />
            <Route path="/DietCalendar" element={<RequireLogin><DietCalendar /></RequireLogin>} />
            <Route path="/DietRecommend" element={<RequireLogin><DietRecommend /></RequireLogin>} />
            <Route path="/diet/:date" element={<RequireLogin><DietCalendar /></RequireLogin>} />
            <Route path="/mypage" element={<RequireLogin><MyPage /></RequireLogin>} />
          </Routes>
        </Layout>
      </ToastProvider>
    </Router>
  );
}

export default App;